module.exports = "query cmsBlocks($identifiers: [String]){ cmsBlocks( identifiers: $identifiers ) { items{ content identifier title } } }"